export const timeInMilliSecondsToWaitForDataToBeDeleted = 300000;
